import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";

const linkClass = "text-sm text-muted-foreground transition-colors hover:text-primary";

export function SiteFooter() {
  return (
    <>
      {/* Let's Work Together CTA — standalone section */}
      <section className="footer-work-together-section border-t border-primary bg-card text-foreground shadow-[0_-12px_40px_-30px_rgba(0,0,0,0.6)]">
        <div className="demo-footer-cta footer-work-together">
          <div className="container mx-auto max-w-7xl px-6 lg:px-10">
            <div className="row">
              <div className="col-lg-12">
                <div className="work-together-box demo-footer-cta-box relative">
                  <div className="work-together-content demo-footer-cta-content">
                    <h3>Let's Collaborate</h3>
                    <h2>Let's Work Together</h2>
                  </div>
                  <div className="work-together-btn demo-footer-cta-button">
                    <Link
                      to="/contact"
                      aria-label="Get in touch"
                      className="group flex h-[150px] w-[150px] flex-col items-center justify-center gap-1 !rounded-full bg-primary text-center text-primary-foreground transition-colors hover:bg-foreground hover:text-background max-md:h-[110px] max-md:w-[110px]"
                    >
                      <img
                        src="/images/arrow-dark.svg"
                        alt=""
                        aria-hidden="true"
                        loading="lazy"
                        decoding="async"
                        className="h-6 w-6 transition-transform group-hover:rotate-45 group-hover:invert"
                      />
                      <span className="text-sm font-bold">Get in Touch</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="site-footer bg-card text-foreground">
        {/* Main footer */}
        <div className="footer-main border-t border-primary">
          <div className="container mx-auto max-w-7xl px-6 py-16 lg:px-10">
            <div className="footer-grid row g-5">
              {/* About */}
              <div className="footer-column footer-brand col-md-6 col-lg-3">
                <Link to="/" aria-label="Phil Carr">
                  <img
                    src="/images/phil-carr-logo.svg"
                    alt="Phil Carr SEO consultant and web design specialist in Barnsley"
                    data-name="Phil Carr SEO consultant and web design specialist in Barnsley"
                    title="Phil Carr SEO consultant and web design specialist in Barnsley"
                    width={132}
                    height={38}
                    loading="lazy"
                    decoding="async"
                    className="img-fluid h-14 w-auto"
                  />
                </Link>
                <p className="mt-5 max-w-xs text-sm text-muted-foreground">
                  Specialist SEO &amp; Web Design services in Barnsley.
                </p>
              </div>

              {/* Quick Links */}
              <div className="footer-column col-md-6 col-lg-2">
                <h3 className="footer-column-title font-display text-lg font-bold">Quick Links</h3>
                <ul className="mt-4 space-y-3 pl-0">
                  <li>
                    <Link to="/about" className={linkClass}>
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/areas" className={linkClass}>
                      Areas
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog" className={linkClass}>
                      News
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className={linkClass}>
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Services */}
              <div className="footer-column footer-services col-md-6 col-lg-5">
                <h3 className="footer-column-title font-display text-lg font-bold">Services</h3>
                <ul className="footer-services-list mt-4 space-y-3 pl-0">
                  <li>
                    <Link to="/services" className={linkClass}>
                      Services Overview
                    </Link>
                  </li>
                  <li>
                    <Link to="/web-design" className={linkClass}>
                      Web Design
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo" className={linkClass}>
                      SEO
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/barnsley" className={linkClass}>
                      SEO Barnsley
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/huddersfield" className={linkClass}>
                      SEO Huddersfield
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/wakefield" className={linkClass}>
                      SEO Wakefield
                    </Link>
                  </li>
                  <li>
                    <Link to="/wordpress-websites" className={linkClass}>
                      WordPress Websites
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/bespoke-seo-website-audits" className={linkClass}>
                      SEO Website Audits
                    </Link>
                  </li>
                  <li>
                    <Link to="/shopify-websites" className={linkClass}>
                      Shopify Websites
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/organic-seo-services" className={linkClass}>
                      Organic SEO Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/barnsley/pricing" className={linkClass}>
                      SEO Pricing
                    </Link>
                  </li>
                  <li>
                    <Link to="/software-development" className={linkClass}>
                      Software Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/link-building-outreach" className={linkClass}>
                      Link Building Outreach
                    </Link>
                  </li>
                  <li>
                    <Link to="/website-management" className={linkClass}>
                      Website Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/seo/technical-seo-support" className={linkClass}>
                      Technical SEO Support
                    </Link>
                  </li>
                  <li>
                    <Link to="/hosting" className={linkClass}>
                      Hosting
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Have Questions */}
              <div className="footer-column footer-contact col-md-6 col-lg-2">
                <h3 className="footer-column-title font-display text-lg font-bold">
                  Have Questions?
                </h3>
                <ul className="mt-4 space-y-3 text-sm">
                  <li>
                    <span className="text-muted-foreground">Phone: </span>
                    <a href="tel:+441226697325" className="text-foreground hover:text-primary">
                      01226 697 325
                    </a>
                  </li>
                  <li>
                    <span className="text-muted-foreground">Email: </span>
                    <a
                      href="mailto:info@phil-carr.co.uk"
                      className="lowercase text-foreground hover:text-primary"
                    >
                      info@phil-carr.co.uk
                    </a>
                  </li>
                  <li>
                    <span className="text-muted-foreground">Location: </span>
                    <span className="text-foreground">Barnsley, South Yorkshire</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright bar */}
        <div className="footer-legal border-t border-border">
          <div className="container mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-6 py-6 text-xs text-muted-foreground md:flex-row md:items-center md:pr-20 lg:px-10 lg:pr-24">
            <p>
              Copyright &copy;{new Date().getFullYear()}. All Rights Reserved. Phil Carr — SEO
              Consultant &amp; Web Strategist
            </p>
            <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
              <li>
                <Link to="/privacy-policy" className="hover:text-primary">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:text-primary">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-primary">
                  Cookies
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="hover:text-primary">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}
